document.addEventListener("DOMContentLoaded", function() {

if (window.location.hash.includes('open-mini-cart')) {
  document.getElementById('mini-cart')?.classList.add('open');
  document.body.classList.add('scroll-lock');
}
    /* Collection slider */
  // Call this right after you inject slides into .swiper-wrapper
  function initOrUpdateProductSliders(root = document) {
    root.querySelectorAll('.products-slider .swiper').forEach(function (slider) {
      const section = slider.closest('.products-slider');
      if (!section) return;

      const prevEl = section.querySelector('.slider-buttons .prev');
      const nextEl = section.querySelector('.slider-buttons .next');

      // If already has a Swiper instance, just update it
      if (slider.swiper) {
        try {
          slider.swiper.update();            // recalc sizes
          slider.swiper.slideTo(0, 0, false); // start at first slide (optional)
          // Make sure nav buttons are wired if DOM got replaced
          if (slider.swiper.params?.navigation) {
            slider.swiper.params.navigation.prevEl = prevEl;
            slider.swiper.params.navigation.nextEl = nextEl;
            slider.swiper.navigation.destroy();
            slider.swiper.navigation.init();
            slider.swiper.navigation.update();
          }
        } catch (e) {}
        return;
      }

      new Swiper(slider, {
        slidesPerView: 1.12,
        spaceBetween: 5,
        mousewheel: { forceToAxis: true },
        freeMode: true,
        navigation: { prevEl: prevEl, nextEl: nextEl },
        breakpoints: {
          768:  { slidesPerView: 2.2, spaceBetween: 5 },
          1024: { slidesPerView: 3.2, spaceBetween: 5 },
          1280: { slidesPerView: 3.5, spaceBetween: 5 },
        },
      });
    });
  }

    initOrUpdateProductSliders();

        /* Footer */
class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    // Ensure panel is hidden initially
    if (this.elements.panel && !this.elements.panel.hasAttribute('hidden')) {
      this.elements.panel.setAttribute('hidden', '');
    }

    // Bind handlers
    this.togglePanel = this.togglePanel.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onItemClick = this.onItemClick.bind(this);

    // Wire up listeners
    if (this.elements.button) {
      this.elements.button.addEventListener('click', this.togglePanel);
    }

    // Close when clicking outside
    document.addEventListener('click', this.onDocumentClick);

    // Item clicks submit the form
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick));
  }

  // Toggle the panel visibility on button click
  togglePanel(event) {
    event.stopPropagation(); // prevent the document click handler from immediately closing it
    if (!this.elements.panel) return;
    this.elements.panel.toggleAttribute('hidden');
  }

  // Close panel when clicking outside the component
  onDocumentClick(event) {
    if (!this.elements.panel) return;
    // If the click happened inside this element, do nothing
    if (this.contains(event.target)) return;
    this.elements.panel.setAttribute('hidden', '');
  }

  // Link click: set input value and submit form
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (this.elements.input) {
      this.elements.input.value = event.currentTarget.dataset.value;
    }
    if (form) form.submit();
  }

  // Clean up document listener when element is removed
  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }
}

customElements.define('localization-form', LocalizationForm);

    /* Product */


  /* Product recommendations */
  const handleProductsRecommendationIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          initOrUpdateProductSliders();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleProductsRecommendationIntersection, {rootMargin: '0px 0px 200px 0px'});

  if (productRecommendationsSection) {
    observer.observe(productRecommendationsSection);
  }
});

var defaultUser = 'info';
var domain = 'hadleypapergoods.co.uk';
var at = '@';

// Get all placeholders
var placeholders = document.querySelectorAll('.email-placeholder');

placeholders.forEach(function (placeholder) {
  // Check if data-email attribute exists
  var user = placeholder.getAttribute('data-email') || defaultUser;

  var fullEmail = user + at + domain;

  var a = document.createElement('a');
  a.href = 'mailto:' + fullEmail;
  a.textContent = fullEmail;
  a.setAttribute('rel', 'noopener noreferrer');

  placeholder.parentNode.replaceChild(a, placeholder);
});

const IMMEDIATE_COUNT = 6;
const BATCH_DELAY_MS = 200;
const preloaded = new Map();

function preloadPreviewImages() {
    const links = document.querySelectorAll('.mega-menu .level-3[data-preview-image]');
    const srcSet = Array.from(new Set(
      Array.from(links).map(l => l.getAttribute('data-preview-image')).filter(Boolean)
    ));

    let index = 0;

    function loadBatch() {
      const batch = srcSet.slice(index, index + IMMEDIATE_COUNT);
      batch.forEach(src => {
        if (preloaded.has(src)) return;
        const img = new Image(250, 165);
        img.src = src;
        preloaded.set(src, img);
        if ('decode' in img) img.decode().catch(() => {});
        img.onerror = () => preloaded.set(src, 'failed');
      });

      index += IMMEDIATE_COUNT;
      if (index < srcSet.length) {
        setTimeout(loadBatch, BATCH_DELAY_MS);
      }
    }

    loadBatch();
  }

  const menuRoot = document.querySelector('.mega-menu');

  menuRoot?.addEventListener('mouseenter', (e) => {
    preloadOnOpen();
  });

  let preloadedOnOpen = false;
  function preloadOnOpen() {
    if (preloadedOnOpen) return;
    preloadedOnOpen = true;
    preloadPreviewImages();
  }

document.addEventListener('DOMContentLoaded', function() {
  const reorderButtons = document.querySelectorAll('.reorder-button');
  
  reorderButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      const lineItems = JSON.parse(this.getAttribute('data-line-items'));
      reorderItems(lineItems, this);
    });
  });
});

async function refreshAccountMiniCart() {
  console.log('[Mini Cart] Starting refresh...');
  
  const wrapper = document.getElementById('shopify-section-mini-cart');
  if (!wrapper) {
    return;
  }
  
  try {
    const res = await fetch(`/?sections=${encodeURIComponent('mini-cart')}`, {
      credentials: 'same-origin'
    });
        
    if (!res.ok) {
      throw new Error(`Section fetch failed with status ${res.status}`);
    }
    
    let html;
    const contentType = res.headers.get('content-type');
    
    try {
      const json = await res.json();
      html = json && json['mini-cart'];
    } catch (jsonError) {
      html = await res.text();
    }
    
    if (!html) {
      throw new Error('Empty section HTML');
    }
    
    wrapper.innerHTML = html;
    
    const mini_cart_div = document.querySelector('[data-mini-cart]');
    if (mini_cart_div) {
      mini_cart_div.classList.add('open');
    } else {
      console.warn('[Mini Cart] Mini cart element not found: [data-mini-cart]');
    }
    
  } catch (e) {
    console.error('[Mini Cart] Refresh failed:', e);
  }
}

function reorderItems(lineItems, button) {
  button.disabled = true;
  button.textContent = 'Adding...';
  
  // Build the cart add request
  const items = lineItems.map(item => ({
    id: item.variant_id,
    quantity: item.quantity
  }));
  
  // Add all items to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ items: items })
  })
  .then(response => response.json())
  .then(data => {
    showNotification('Items added to cart successfully!', 'success');
    button.disabled = false;
    button.textContent = 'Add all items to basket';
    
    refreshAccountMiniCart();
  })
  .catch(error => {
    console.error('Error:', error);
    showNotification('Some items could not be added. They may be out of stock.', 'error');
    button.disabled = false;
    button.textContent = 'Add all items to basket';
  });
}

function showNotification(message, type) {
  // Remove existing notification if any
  const existing = document.querySelector('.reorder-notification');
  if (existing) {
    existing.remove();
  }
  
  // Create new notification
  const notification = document.createElement('div');
  notification.className = `reorder-notification ${type === 'error' ? 'error' : ''}`;
  notification.textContent = message;
  document.body.appendChild(notification);
  
  // Auto-remove after 3 seconds
  setTimeout(() => {
    notification.remove();
  }, 3000);
}